import {Moment} from "moment"

export type WorkDay = {
    dayOfWeek: number
    name: string
    enabled: boolean
    allDay: boolean
    startTime?: Moment
    endTime?: Moment
    maxHoursEnabled?: boolean
    bonusMinutesEnabled?: boolean
    distEdEnabled?: boolean
    maxHours?: number
    bonusMinutesAfter?: number
    bonusMinutesBefore?: number
}

const WEEKDAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const INITIAL_WORK_WEEK: WorkDay[] = WEEKDAY_NAMES.map((name, index) => {
    return {
        dayOfWeek: index,
        name,
        enabled: ![0, 6].includes(index),
        allDay: false
    }
})

export {INITIAL_WORK_WEEK, WEEKDAY_NAMES}
